import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import style from './footer-layout.scss';

import { Button, TextButton } from 'wix-style-react';

const isSingleButtonCTA = (primaryButtonLabel, secondaryButtonLabel, footer) =>
  [!!primaryButtonLabel, !!secondaryButtonLabel, !!footer].filter((b) => b)
    .length === 1;

const getButtonAppearanceProps = ({
  primaryButtonHeight,
  primaryButtonLabel,
  secondaryButtonLabel,
  footer,
  theme,
}) => ({
  size:
    primaryButtonHeight ||
    isSingleButtonCTA(primaryButtonLabel, secondaryButtonLabel, footer)
      ? theme === 'error'
        ? 'medium'
        : 'small'
      : 'medium',
  skin:
    theme === 'error'
      ? 'destructive'
      : theme === 'fancy'
      ? 'premium'
      : 'standard',
  priority:
    theme !== 'error' &&
    theme !== 'fancy' &&
    primaryButtonLabel &&
    !secondaryButtonLabel
      ? 'secondary'
      : 'primary',
});

const FooterLayout = ({
  size,
  theme,
  primaryButtonLabel,
  primaryButtonHeight,
  onPrimaryButtonClick,
  secondaryButtonLabel,
  onSecondaryButtonClick,
  footer,
}) => (
  <div className={classnames(style[`size-${size}`], style.root)}>
    <div
      className={
        style[
          primaryButtonLabel && secondaryButtonLabel ? `two-cta` : `one-cta`
        ]
      }
    >
      {primaryButtonLabel && (
        <div className={style[`primary-button${footer ? '-with-footer' : ''}`]}>
          <Button
            {...getButtonAppearanceProps({
              primaryButtonHeight,
              primaryButtonLabel,
              secondaryButtonLabel,
              footer,
              theme,
            })}
            dataHook="footer-primary-cta"
            onClick={onPrimaryButtonClick}
          >
            {primaryButtonLabel}
          </Button>
        </div>
      )}
      {secondaryButtonLabel ? (
        <div className={style[`secondary-button`]}>
          <TextButton
            size="small"
            dataHook="footer-secondary-cta"
            onClick={onSecondaryButtonClick}
          >
            {secondaryButtonLabel}
          </TextButton>
        </div>
      ) : (
        footer && <div className={style.footer}>{footer}</div>
      )}
    </div>
  </div>
);

FooterLayout.propTypes = {
  primaryButtonLabel: PropTypes.string,
  primaryButtonHeight: PropTypes.string,
  onPrimaryButtonClick: PropTypes.func,
  secondaryButtonLabel: PropTypes.string,
  onSecondaryButtonClick: PropTypes.func,
  footer: PropTypes.node,
  size: PropTypes.oneOf(['small', 'medium', 'large', 'extra-large']),
  theme: PropTypes.oneOf(['notification', 'flow', 'fancy', 'error']),
};

export default FooterLayout;
